module.exports = __webpack_public_path__ + "static/media/icon5.12673549.webp";